import { IPharmacyStock } from 'app/shared/model/pharmacy-stock.model';
import { IPharmacyBillItem } from 'app/shared/model/pharmacy-bill-item.model';
import { IPharmacyRefundBill } from 'app/shared/model/pharmacy-refund-bill.model';
import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IPharmacyReturnBill } from 'app/shared/model/pharmacy-return-bill.model';
import { IPharmacyReturnBillItem } from 'app/shared/model/pharmacy-return-bill-item.model';

export interface IPharmacyRefundBillItem {
  id?: string;
  chargedMrp?: number;
  refundPaid?: number;
  refundQty?: number;
  soldQty?: number;
  manufacDate?: number;
  expDate?: number;
  active?: boolean;
  cursor?: number;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  pharmacyStock?: IPharmacyStock | null;
  saleBillItem?: IPharmacyBillItem | null;
  refundBill?: IPharmacyRefundBill | null;
  saleBill?: IPharmacyBill | null;
  returnBill?: IPharmacyReturnBill | null;
  returnItem?: IPharmacyReturnBillItem | null;
}

export const defaultValue: Readonly<IPharmacyRefundBillItem> = {
  active: false,
};
